import { render, staticRenderFns } from "./DuplicatePortCall.vue?vue&type=template&id=70482a18&scoped=true&"
import script from "./DuplicatePortCall.vue?vue&type=script&lang=js&"
export * from "./DuplicatePortCall.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatePortCall.vue?vue&type=style&index=0&id=70482a18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70482a18",
  null
  
)

export default component.exports